import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Link,
  styled,
  Typography,
} from "@mui/material";
import { ChangeEvent } from "react";

interface CustomCheckboxProps {
  handleChange: (event: ChangeEvent<HTMLInputElement>, checked: any) => void;
  checked: boolean;
  route: string;
}

const CustomLicenseCheckBox = ({
  handleChange,
  checked,
  route,
}: CustomCheckboxProps) => {
  return (
    <FormGroup sx={{ my: "12px" }}>
      <FormControlLabel
        control={<LicenseCheckbox onChange={handleChange} checked={checked} />}
        label={
          <Typography component="p">
            I agree to the{" "}
            <Link
              href={route}
              target="_blank"
              sx={{ color: "#FDD649", textDecoration: "none" }}
            >
              LICENSE AND SUBSCRIPTION AGREEMENT
            </Link>{" "}
          </Typography>
        }
      />
    </FormGroup>
  );
};

export default CustomLicenseCheckBox;

const LicenseCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "#414141",
  "&.Mui-checked": {
    color: "#FDD649",
  },
  "& .MuiSvgIcon-root": { width: "18px", height: "18px" },
}));
